<form (submit)="onSubmit(form)"
      #form>
  <label>
    <input type="search"
           name="searchTerms"
           [form]="formName()"
           [attr.value]="initialValue()"
           (input)="onChange($event)">
  </label>
  <input type="number"
         name="from"
         readonly
         value="0">
  <input type="number"
         name="size"
         readonly
         value="10">
  <button type="submit"
          [attr.aria-label]="'PRODUCT.SEARCH_BAR_SUBMIT'|translate"
          button="solid"
          icon="search">
  </button>
</form>
